// Resolves the marketing landing URL for the current environment.
// - staging → https://landing-staging.kredz.com.br
// - production → https://kredz.com.br
// - local/dev (no REACT_APP_ENV) → https://kredz.com.br (safe default)
//
// REACT_APP_ENV is injected at build time by the CodeBuild buildspec
// (KREDZ_ENV → REACT_APP_ENV) — same source of truth as the env banner.
export function getLandingUrl() {
  const env = (process.env.REACT_APP_ENV || "").toLowerCase();
  if (env === "staging") return "https://landing-staging.kredz.com.br";
  return "https://kredz.com.br";
}
